import React, { useState } from "react";

const uniqueSources = (sources) => Array.from(new Set((sources || []).filter(Boolean)));

export default function VehicleCardImage({
  alt,
  className,
  height,
  loading = "lazy",
  placeholderClassName,
  sources,
  testId: testIdProp,
  "data-testid": dataTestId,
  width,
}) {
  const testId = testIdProp || dataTestId;
  const sourceKey = (sources || []).filter(Boolean).join("|");
  const candidates = uniqueSources(sources);
  const [selection, setSelection] = useState({ key: sourceKey, sourceIndex: 0 });
  const sourceIndex = selection.key === sourceKey ? selection.sourceIndex : 0;
  const source = candidates[sourceIndex];

  const showNextSource = () => {
    setSelection((currentSelection) => {
      const currentIndex = currentSelection.key === sourceKey
        ? currentSelection.sourceIndex
        : 0;

      return {
        key: sourceKey,
        sourceIndex: Math.min(currentIndex + 1, candidates.length),
      };
    });
  };

  if (!source) {
    return (
      <div
        aria-label={alt}
        className={placeholderClassName || className}
        data-testid={`${testId}-placeholder`}
        role="img"
      />
    );
  }

  return (
    <img
      alt={alt}
      className={className}
      data-testid={testId}
      decoding="async"
      height={height}
      loading={loading}
      onError={showNextSource}
      src={source}
      width={width}
    />
  );
}